import baseModule from '@/store/shared/graphql'
import api from '@/api/student'

const STORE_TYPE = 'STUDENTS'
const API_DATA_KEY = 'student'
const API_DATA_BY_ID_KEY = 'id'
const defaultModule = baseModule(STORE_TYPE, API_DATA_BY_ID_KEY, API_DATA_KEY, api)

export default {
    state: {
        ...defaultModule.state,
    },
    getters: {
        ...defaultModule.getters,
    },
    mutations: {
        ...defaultModule.mutations,
    },
    actions: {
        ...defaultModule.actions,
    },
    namespaced: true,
}
